// extracted by mini-css-extract-plugin
export default {"keyValueListContainer":"YgPKvr"};